export default __webpack_public_path__ + "static/media/buddy6.20f46b85.jpg";